import React, { ReactElement} from 'react'
import { errorFilterIcon } from '../../../../../shared/icons';
import styles from "./ErrorMsg.module.scss"

interface ErrorMsgProps {
    errors: string[];
    customClass?: string;
}

function ErrorMsg(props: ErrorMsgProps): ReactElement {
    const errors = typeof props.errors === "string" ? [props.errors] : props.errors;

    if (!errors || errors.length === 0) return null as any;

    return (
        <>
            <span className={styles.errorIcon}>{errorFilterIcon}</span>
            <div className={[styles.errorMsgContent, props.customClass || ""].join(" ")}>
                {errors.map((error: string, i: number) => <p key={i}>{error}</p>)}
            </div>
        </>
    )

}

export default ErrorMsg



